import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getCommonButtonTypeDefault, getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { Icon } from '@skatteetaten/ds-icons';
import { Spinner } from '@skatteetaten/ds-progress';
import './styles.css';


const getIconButtonSizeDefault = ()=>'medium';
const getIconButtonBrightnessDefault = ()=>'default';

var styles = {
    "button": "IconButton-module_button__sbFDf",
    "icon": "IconButton-module_icon__-WkOY",
    "spinner": "IconButton-module_spinner__sUisW",
    "button_extraSmall": "IconButton-module_button_extraSmall__t4las",
    "button_small": "IconButton-module_button_small__wDpfG",
    "button_medium": "IconButton-module_button_medium__-F2uK",
    "button_large": "IconButton-module_button_large__rV88k",
    "button_outlined": "IconButton-module_button_outlined__P-457"
};

const IconButton = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, brightness = getIconButtonBrightnessDefault(), size = getIconButtonSizeDefault(), spinnerTitle, svgPath, accessKey, disabled, title, type = getCommonButtonTypeDefault(), ariaDescribedby, ariaExpanded, hasSpinner, isOutlined, onClick, onBlur, onFocus }, ref)=>{
    const sizeClassName = styles[`button_${size}`];
    const outlineClassName = isOutlined ? styles.button_outlined : '';
    return /*#__PURE__*/ jsxs("button", {
        ref: ref,
        id: id,
        className: `${styles.button} ${sizeClassName} ${outlineClassName} ${className}`.trim(),
        lang: lang,
        "data-testid": dataTestId,
        "data-brightness": brightness,
        disabled: disabled,
        accessKey: accessKey,
        type: type,
        "aria-describedby": ariaDescribedby,
        "aria-expanded": ariaExpanded,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        children: [
            !hasSpinner && /*#__PURE__*/ jsx(Icon, {
                className: styles.icon,
                svgPath: svgPath,
                title: title
            }),
            hasSpinner && /*#__PURE__*/ jsx(Spinner, {
                className: styles.spinner,
                color: disabled ? 'black' : 'blue',
                size: size === 'extraSmall' ? 'small' : size,
                hideTitle: true,
                children: spinnerTitle
            })
        ]
    });
});
IconButton.displayName = 'IconButton';

export { IconButton, getIconButtonBrightnessDefault, getIconButtonSizeDefault };
